import { useTheme } from "../hooks/useTheme";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Colors } from "../utils/colors";
import { formatDate } from "../utils/GetLongDate";
import { formatAMPM } from "@markit/common.utils";

type DateTimePickerInputProps = {
  timestamp: string;
  onChange: (date: Date | null) => void;
};

const DateTimePickerInput = (props: DateTimePickerInputProps) => {
  const { timestamp, onChange } = props;
  const { theme } = useTheme();

  // Disallow selection of earlier date for scheduled texts
  const filterPassedTime = (time: any) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  };

  return (
    <ReactDatePicker
      selected={new Date(timestamp)}
      showTimeSelect
      minDate={new Date()}
      filterTime={filterPassedTime}
      timeIntervals={5}
      onChange={onChange}
      customInput={
        <div
          className="AlignedRow"
          style={{
            backgroundColor: Colors.WHITE,
            cursor: "pointer",
            border: "0.5px solid #666666",
            borderRadius: 8,
          }}
        >
          <div
            style={{
              cursor: "pointer",
              borderRight: "0.5px solid #666666",
              paddingBlock: 10,
              paddingInline: 14,
              ...theme.PrimaryText,
            }}
          >
            {formatDate(new Date(timestamp), true, true, true)}
          </div>
          <div
            style={{
              cursor: "pointer",
              paddingBlock: 10,
              paddingInline: 14,
              ...theme.PrimaryText,
            }}
          >
            {formatAMPM(new Date(timestamp))}
          </div>
        </div>
      }
    />
  );
};

export default DateTimePickerInput;
